import React, { useMemo } from "react";
import { User, Mail } from "lucide-react";
import Card from "./Card";
import { displayValue } from "./utils";
import textTranslator from "../../../../utils/useTextTranslator";
import Txt from "../../../Text";

const Text = ({ children, className, page = "APPOINTMENTS" }) => {
	return (
		<Txt page={page} className={className} keyName={page}>
			{children}
		</Txt>
	);
};

const AppointmentProviderCard = ({ appointment, darkMode, arClass }) => {
	const provider = appointment?.provider || {};

	const fullName = useMemo(() => {
		if (!provider) return "-";
		const first = provider?.firstName || provider?.first_name || "";
		const last = provider?.lastName || provider?.last_name || "";
		const joined = `${first} ${last}`.trim();
		return joined || "-";
	}, [provider]);

	return (
		<Card
			title={textTranslator("Provider", "APPOINTMENTS")}
			subtitle={textTranslator("Doctor", "APPOINTMENTS")}
			icon={User}
			darkMode={darkMode}
			arClass={arClass}
		>
			<div className="space-y-4">
				<div className="flex items-center justify-between">
					<span className={darkMode ? "text-gray-400" : "text-slate-600"}>
						<Text>Provider Name</Text>
					</span>
					<span className={darkMode ? "text-white font-semibold" : "text-slate-900 font-semibold"}>
						{fullName}
					</span>
				</div>

				{provider?.email && (
					<div className="flex items-center gap-2">
						<Mail className="h-4 w-4" />
						<div className="flex items-center justify-between flex-1">
							<span className={darkMode ? "text-gray-400" : "text-slate-600"}>
								<Text>Email</Text>
							</span>
							<span className={darkMode ? "text-white" : "text-slate-900"}>
								{displayValue(provider.email)}
							</span>
						</div>
					</div>
				)}

				{provider?.specialization && (
					<div className="flex items-center justify-between">
						<span className={darkMode ? "text-gray-400" : "text-slate-600"}>
							<Text>Specialization</Text>
						</span>
						<span className={darkMode ? "text-white" : "text-slate-900"}>
							{displayValue(provider.specialization)}
						</span>
					</div>
				)}
			</div>
		</Card>
	);
};

export default AppointmentProviderCard;
